export default __webpack_public_path__ + "static/media/Lato-Light.bfc37ff1.ttf";